import { defineComponent as _defineComponent } from 'vue'
import { computed, onBeforeMount, onBeforeUnmount, ref, watch } from 'vue'
import { emitter } from '@/plugins/emitter'
import { useHostServices } from '@/composables/format-edit/useHostServices'
import { useFormatLocalData } from '@/composables/format-edit/useFormatLocalData'
import {
  createEmptyShibouDoukishoFormatData,
  provideShibouDoukishoFormatData
} from '@/composables/format-edit/useShibouDoukishoFormatData'
import ShibouDoukishoReasonCard from '@/components/format-edit/shibou-doukisho/ShibouDoukishoReasonCard.vue'
import ShibouDoukishoCreateDateCard from '@/components/format-edit/shibou-doukisho/ShibouDoukishoCreateDateCard.vue'
import ShibouDoukishoConfirmCard from '@/components/format-edit/shibou-doukisho/ShibouDoukishoConfirmCard.vue'
import CompletedOutputPanel from '@/components/format-edit/completed/CompletedOutputPanel.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ShibouDoukishoEdit',
  props: {
    basicData: null,
    formatId: null,
    previewFormat: null,
    currentCardId: null,
    exampleSentences: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
  basicData: Record<string, unknown>
  formatId?: string
  previewFormat?: { errorMessages?: Record<string, string> } | null
  currentCardId?: string
  exampleSentences?: Record<string, unknown>
};



const { formLib } = useHostServices()

const { formatData, saveKey, saveName, changeCount } = useFormatLocalData({
  saveName: 'shiboudoukisho',
  saveOtherName: 'rirekisho',
  createEmpty: createEmptyShibouDoukishoFormatData
})
provideShibouDoukishoFormatData(formatData)

const mailPdfEnabled = ref(true)
const downloadPdfEnabled = ref(true)
const isSendYagiEmailEnabled = ref(true)

const previewErrors = computed(() => {
  if (!props.previewFormat || !props.previewFormat.errorMessages) return {}
  return props.previewFormat.errorMessages
})

const getMode = computed(() => process.env.VUE_APP_MODE)

function dataChanged() {
  mailPdfEnabled.value = true
  downloadPdfEnabled.value = true
}

watch(
  () => formatData.createDate,
  (newValue) => {
    if (newValue == null) return
    formatData.writeDate = formLib.dateFormat(
      newValue as Date,
      'yyyy年 m月 d日'
    )
  }
)

onBeforeMount(() => {
  if (formatData.createDate === null) {
    formatData.createDate = formLib.getToday()
  }
  emitter.on('basic-data-changed', dataChanged)
  emitter.on('format-data-changed', dataChanged)
})

onBeforeUnmount(() => {
  emitter.off('basic-data-changed', dataChanged)
  emitter.off('format-data-changed', dataChanged)
})

expose({
  saveName,
  saveKey,
  formatData,
  changeCount
})

return { __sfc: true,props, formLib, formatData, saveKey, saveName, changeCount, mailPdfEnabled, downloadPdfEnabled, isSendYagiEmailEnabled, previewErrors, getMode, dataChanged, ShibouDoukishoReasonCard, ShibouDoukishoCreateDateCard, ShibouDoukishoConfirmCard, CompletedOutputPanel }
}

})